import type {ScreenDef} from './types';

export const salesOrdersFields: ScreenDef = {
    image: 'Sales Orders',
    sections: [
        {
            name: 'Sales Orders',
            entity: 'salesorder',
            columns: [
                {field: 'name'},
                {field: 'statuscode'},
                {field: 'totalamount'},
                {field: 'customerid'},
                {field: 'salesordercustomeridcontactcontactid.emailaddress1', labelOverride: 'Customer Email'},
                {field: 'createdon'},
            ],
        },
        {
            name: 'Order Items',
            entity: 'salesorderdetail',
            columns: [
                {field: 'lon_pdecode'},
                {field: 'salesorderdetailname'},
                {field: 'quantity'},
                {field: 'lon_discountpercent', labelOverride: 'Discount'},
                {field: 'lon_exporteddate'},
                {field: 'lon_status'},
                {field: 'lon_bonusreason'},
            ],
        },
    ],
};
